import { cn } from '@lib/utils'

interface CheckerAccentProps {
  className?: string
  cols?: number
  rows?: number
  cell?: number
}

/** Petit damier pixel (accent ▞▞) — puce de section, séparateur, coin de carte. */
export function CheckerAccent({ className, cols = 4, rows = 2, cell = 4 }: CheckerAccentProps) {
  const squares = []
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      if ((r + c) % 2 === 0) {
        squares.push(<rect key={`${r}-${c}`} x={c * cell} y={r * cell} width={cell} height={cell} fill="currentColor" />)
      }
    }
  }
  return (
    <svg
      className={cn('inline-block text-white/70', className)}
      width={cols * cell}
      height={rows * cell}
      viewBox={`0 0 ${cols * cell} ${rows * cell}`}
      aria-hidden="true"
    >
      {squares}
    </svg>
  )
}
